import { ANALYTICS_EVENTS, ANALYTICS_EVENT_ACTIONS } from '../../../utils/constants';

import Button from '@mui/material/Button';
import ErrorBoundary from '../../ErrorBoundary';
import GetAppIcon from '@mui/icons-material/GetApp';
import { PIPELINE_NETWORK_GOOGLE_ANALYTICS_TAG } from '../constants';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { defaultDimensions } from '../../../utils/analytics';
import { downloadXlsx } from '../../Downloads/helpers';
import { getUserId } from '../../../utils/auth';
import makeStyles from '@mui/styles/makeStyles';
import { useSnackBarContext } from '../../../contexts/SnackbarContext';

const useStyles = makeStyles((theme) => ({
  button: {
    ...theme.palette.button,
    width: '100%',
    margin: theme.spacing(1),
    justifyContent: 'space-evenly',
  },
  buttonContainer: {
    ...theme.palette.mapInfoSection,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  label: {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
  },
  orangeIcon: {
    ...theme.palette.accentText,
  },
}));

export default ({ pipelineNetwork }) => {
  const classes = useStyles();
  const { setSnack, flashDownloadLimitSnack } = useSnackBarContext();

  const downloadCallback = (errorHandler, successHandler) => {
    const path = 'pipeline-network/export-throughput/';
    const body = {
      pipelineNetworkId: pipelineNetwork.id,
    };
    const downloadName = `Welligence - Pipeline Network Throughput - ${pipelineNetwork.name}.xlsx`;

    downloadXlsx(path, body, downloadName, errorHandler, successHandler);
  };

  const handleDownload = () => {
    // gtag
    gtag('event', ANALYTICS_EVENTS.event, {
      event_category: PIPELINE_NETWORK_GOOGLE_ANALYTICS_TAG,
      event_action: ANALYTICS_EVENT_ACTIONS.download,
      event_label: 'pipeline_network_throughput_by_asset_excel',
      userId: getUserId(),
      ...defaultDimensions,
    });
    // setSnack
    setSnack({
      open: true,
      message: 'Your download should begin shortly.',
      severity: 'success',
    });
    // downloadCallback
    downloadCallback(
      (errors) => setSnack({ open: true, message: errors[0].message, severity: 'error' }),
      flashDownloadLimitSnack,
    );
  };

  return (
    <ErrorBoundary>
      <div className={classes.buttonContainer}>
        {pipelineNetwork ? (
          <Tooltip
            title="Pipeline Network Throughput By Asset"
            aria-label="pipeline network throughput by asset"
          >
            <Button className={classes.button} onClick={() => handleDownload()} variant="contained">
              <GetAppIcon fontSize="small" color="primary" className={classes.orangeIcon} />
              <div className={classes.label}>
                Pipeline Network Throughput
                <br />
                By Asset
              </div>
            </Button>
          </Tooltip>
        ) : null}
      </div>
    </ErrorBoundary>
  );
};
